import Axios from 'axios';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

class RESTServicesService {
  #dispatchQoreAxiosInstance;

  constructor() {
    this.#dispatchQoreAxiosInstance = Axios.create({
      baseURL: process.env.REACT_APP_DISPATCH_QORE_API,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY,
      },
      withCredentials: true,
    });
  }

  /**
   * Returns a list of all services from the DB or a redis cache
   * with a 24 hour TTL
   * @returns {Promise<AxiosResponse>}
   */
  async getServices() {
    const response = await this.#dispatchQoreAxiosInstance.get('/get-services');
    return response.data;
  }
}

export default RESTServicesService;
